<template>
  <div>
    <Header state="fourOhfour" />
    <div class="content">
      <h1>404</h1>
      <p>Sorry, the page you are trying to visit does exist.</p>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header/Header';

export default {
  name: 'FourOhFour',
  components: {
    Header,
  },
};
</script>

<style lang="scss" scoped>
  .content {
    text-align: center;
    margin-top: 4rem;
  }
</style>




// WEBPACK FOOTER //
// src/view/FourOhFour.vue